<template>
  <div>

    <topMenu Sel="3"></topMenu>
    <div>
    	<img src="../../../static/image/img5.png" style="width: 100%;"/>
    </div>

    <div class="box">
    	<div class="titleleft">
    		<span class="titile1">关于我们</span>
    		<span class="titile2">ABOUT US</span>
    	</div>
    	<div class="boxright">
    		<p>&nbsp;&nbsp;&nbsp;
    			卡丁生活是一款以卡为主题的本地生活服务类电商平台,解决了实体商家锁客难拓客难复购难的问题现在是共享,
    			分享经济时代卡丁生活致力于推动实体经济发展以同一行业限定区域保护的方式让实体商家异界联盟商家们共享
    			自家的产品,会员才能更有效健康的发展同时更有效的把自家流量变现获得额外收益起到了真正意义的联盟效果
    			实现商家与消费者的互惠互利。
    		</p>
    		<p>&nbsp;&nbsp;&nbsp;
    			  消费者以卡丁的身份进入平台消费过程中会一路晋升到最高等级,享受更优惠待遇,让卡丁们在消费的同时有一个
    			  新的生活娱乐体验,其次,卡丁可以帮助商家分享他们的产品给身边的朋友,朋友得到了优惠,卡丁也会得到了应得
    			  的报酬,这就是卡丁生活存在的意义。
    		</p>
    		<p>&nbsp;&nbsp;&nbsp;
    			用卡丁生活,永远有余额。
    		</p>
    	</div>
    	<div class="boxleft">
    		<img src="../../../static/image/img7.png" style="width: 100%;"/>
    	</div>
    </div>

    <div class="box">
    	<div class="titleright">
    		<span class="titile1">新闻资讯</span>
    		<span class="titile2">NEWS AND INFORMATION</span>
    	</div>
    	<div class="boxleft">
    		<img src="../../../static/image/img8.png" style="width: 100%;"/>
    	</div>
    	<div class="boxright">
    		<p>&nbsp;&nbsp;&nbsp;
    			卡丁生活是一款以卡为主题的本地生活服务类电商平台,解决了实体商家锁客难拓客难复购难的问题现在是共享,
    			分享经济时代卡丁生活致力于推动实体经济发展以同一行业限定区域保护的方式让实体商家异界联盟商家们共享
    			自家的产品,会员才能更有效健康的发展同时更有效的把自家流量变现获得额外收益起到了真正意义的联盟效果
    			实现商家与消费者的互惠互利。
    		</p>
    		<p>&nbsp;&nbsp;&nbsp;
    			  消费者以卡丁的身份进入平台消费过程中会一路晋升到最高等级,享受更优惠待遇,让卡丁们在消费的同时有一个
    			  新的生活娱乐体验,其次,卡丁可以帮助商家分享他们的产品给身边的朋友,朋友得到了优惠,卡丁也会得到了应得
    			  的报酬,这就是卡丁生活存在的意义。
    		</p>
    		<p>&nbsp;&nbsp;&nbsp;
    			用卡丁生活,永远有余额。
    		</p>
    	</div>
    </div>

    <div class="box">
    	<div class="titleleft">
    		<span class="titile1">招贤纳士</span>
    		<span class="titile2">RECRUITING</span>
    	</div>
    	<div class="boxright">
    		<p>&nbsp;&nbsp;&nbsp;
    			卡丁生活是一款以卡为主题的本地生活服务类电商平台,解决了实体商家锁客难拓客难复购难的问题现在是共享,
    			分享经济时代卡丁生活致力于推动实体经济发展以同一行业限定区域保护的方式让实体商家异界联盟商家们共享
    			自家的产品,会员才能更有效健康的发展同时更有效的把自家流量变现获得额外收益起到了真正意义的联盟效果
    			实现商家与消费者的互惠互利。
    		</p>
    		<p>&nbsp;&nbsp;&nbsp;
    			  消费者以卡丁的身份进入平台消费过程中会一路晋升到最高等级,享受更优惠待遇,让卡丁们在消费的同时有一个
    			  新的生活娱乐体验,其次,卡丁可以帮助商家分享他们的产品给身边的朋友,朋友得到了优惠,卡丁也会得到了应得
    			  的报酬,这就是卡丁生活存在的意义。
    		</p>
    		<p>&nbsp;&nbsp;&nbsp;
    			用卡丁生活,永远有余额。
    		</p>
    		<div class="apply">我要应聘</div>
    	</div>
    	<div class="boxleft">
    		<img src="../../../static/image/img9.png" style="width: 100%;"/>
    	</div>
    </div>


    <div class="zpcon">
    	<div>
    		<div style="width: 80px;height: 80px;background: #333;"></div>
    		<p>二维码</p>
    	</div>
    	<div>
    		<div style="width: 80px;height: 80px;background: #333;"></div>
    		<p>二维码</p>
    	</div>
    	<div>
    		<div style="width: 80px;height: 80px;background: #333;"></div>
    		<p>二维码</p>
    	</div>
    	<div>
    		<div style="width: 80px;height: 80px;background: #333;"></div>
    		<p>二维码</p>
    	</div>
    	<div>
    		<div style="width: 80px;height: 80px;background: #333;"></div>
    		<p>二维码</p>
    	</div>
    </div>
    <div class="lianxi">
    	<p>联系方式</p>
    	<div>
    		<span>客服电话:000-01040101</span>
    		<span>微博:1033153688</span>
    		<span>微信:1033153688</span>
    		<span>快手:000-01040101</span>
    		<span>抖音:1033153688</span>
    		<span>邮箱:1033153688</span>
    		<span>QQ:000-01040101</span>
    	</div>
    </div>
    <div style="width: 100%;background: #434343;height: 100px;display: flex;align-items: center;justify-content: center;">
    	<img src="../../../static/image/img2.png" style="height:60px;"/>
    	<img src="../../../static/image/logo1.png" style="height:60px;"/>
    </div>
    <div class="footer">
    	<div style="padding-top: 20px;box-sizing: border-box;padding-left: 20px;">
    		<span>营业执照</span>
    		<span>加入我们</span>
    		<span>在线客服</span>
    	</div>
    	<p>版权所有：辽宁卡丁生活科技有限公司</p>
    	<p>辽ICP备20007334号</p>
    </div>
  </div>
</template>

<script>
  import topMenu from './components/topMenu.vue'
  export default {
    components:{
      topMenu
    },
    data() {
      return {

      }
    },
    //初始化
    created(){

    },
    methods:{

    }
  }
</script>

<style scoped>
  /* 设置滚动条的样式 */
  ::-webkit-scrollbar {
  	width: 2px;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
  	border-radius: 10px;
  	background: #d2d2d2;
  }

  .header {
  	width: 100%;
  	height:60px;
  	box-sizing: border-box;
  	display: flex;
  	align-items: center;
  	justify-content: space-around;
  }
  .logo1 {
  	height:40px;
  }
  .logo2 {
  	height:40px;
  }
  .header span {
  	display: inline-block;
  	width: 100px;
  	text-align: center;
  	font-size: 16px;
  	line-height:50px;
  	color: #111;
  	font-weight:bold;
  	font-family:'黑体';
  }
  .box {
  	width:1100px;
  	height:370px;
  	margin: 20px auto 50px;
  	display: flex;
  	align-items: center;
  	justify-content: space-between;
  	box-sizing: border-box;
  	position: relative;
  	top: 50px;
  }
  .boxleft {
  	width: 44%;
  	height: 100%;
  	box-sizing: border-box;
  	position:relative;
  }
  .boxright {
  	width: 54%;
  	height: 100%;
  	box-sizing: border-box;
  }
  .boxright p {
  	font-size: 14px;
  	line-height:30px;
  	font-family: '黑体';
  	color: #333;
  	padding-left: 20px;
  }
  .footer {
  	width: 100%;
  	height: 100px;
  	box-sizing: border-box;
  }
  .footer div span {
  	margin-left: 20px;
  	font-size: 14px;
  	line-height: 20px;
  	color: #999;
  }
  .footer p {
  	text-align: center;
  	font-size: 15px;
  	line-height: 20px;
  	color: #666;
  	margin-bottom:5px;
  }
  .titleleft {
  	position: absolute;
  	 top: -50px;
  	 left: 0px;
  }
  .titleright {
  	position: absolute;
  	 top: -50px;
  	 right: 0px;
  }
  .titile1 {
  	color: #f2ea61;
  	border-bottom:5px solid #f2ea61;
  	font-size:30px;
  	line-height:35px;
  	font-family: '黑体';
  	padding-bottom:10px;
  	margin-left: 20px;
  }
  .titile2 {
  	color: #999;
  	font-size:30px;
  	line-height:35px;
  	font-family: '黑体';
  	padding-bottom:10px;
  }
  .apply {
  	width:400px;
  	margin: 20px auto 0px;
  	background:#f2ea61;
  	color: #666;
  	font-size: 15px;
  	height:40px;
  	line-height: 40px;
  	text-align: center;
  	border-radius:20px;
  	letter-spacing: 1px;
  	font-family: '黑体';
  }
  .zpcon{
  	width:900px;
  	height:150px;
  	margin: 20px auto;
  	display: flex;
  	align-items: center;
  	justify-content: space-between;
  	box-sizing: border-box;
  }
  .zpcon>div>p {
  	text-align: center;
  }
  .lianxi {
  	 width:100%;
  	 height:120px;
  	 background: #ccc;
  }
  .lianxi p {
  	text-align: center;
  	color: #111;
  	font-family: '黑体';
  	font-size:22px;
  	line-height:40px;
  }
  .lianxi>div {
  	display: flex;
  	align-items: center;
  	justify-content: space-around;
  	flex-wrap: wrap;
  }
  .lianxi>div>span {
  	width: 22%;
  	display: inline-block;
  	font-family: "微软雅黑";
  	line-height: 35px;
  	text-align: center;
  	color: #666;
  	padding-left: 10px;
  	box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/official/gywm.vue